export const znNumbers = [
    "零", "一", "二", "三", "四", "五", "六", "七"
]